import React from 'react';
import { Button } from '../../../../../components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../../../../components/ui/dialog';
import { Download, FileText, Trash2 } from 'lucide-react';
import { SpecificationDocument } from '../../../types/index';

interface DocumentDownloadModalProps {
  isOpen: boolean;
  onClose: () => void;
  documents: any[];
  onDownload: (spec: any) => void;
  onDelete?: (doc: any) => void;
  title?: string;
  canDelete?: boolean;
}

export const DocumentDownloadModal: React.FC<DocumentDownloadModalProps> = ({
  isOpen,
  onClose,
  documents,
  onDownload,
  onDelete,
  title = 'Download Documents',
  canDelete = false
}) => {
  const handleDownload = (spec: any) => {
    onDownload(spec);
  };

  const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  if(!documents || documents.length === 0) return null;
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="w-[90vw] max-w-[720px] pr-14">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-[18px] font-semibold text-blueprint-blue leading-tight">
            <FileText className="h-4 w-4 text-heritage-grey" />
            {title} ({documents.length} files)
          </DialogTitle>
        </DialogHeader>

        <div className="py-4 max-h-96 overflow-y-auto">
          {documents && documents.length === 0 ? (
            <div className="text-center py-8 text-[13px] text-heritage-grey">
              No documents available for download
            </div>
          ) : (
            <div className="space-y-2">
              {documents && documents.length > 0 && documents.map((doc, index) => (

                <React.Fragment key={doc.id || index}>{doc.fileName &&
                  <div
                    className="flex items-center justify-between p-3 bg-page-bg border border-[#E2E5EA] rounded-lg hover:bg-white transition-colors"
                  >
                    <div className="flex items-center gap-3 flex-1 min-w-0">
                      <FileText className="h-5 w-5 text-heritage-grey flex-shrink-0" />
                      <div className="flex-1 min-w-0">
                        <p className="text-[13px] font-medium text-text-grey truncate">
                          {doc.fileName || doc.file_name}
                        </p>
                        {doc.uploadDate && <div className="flex items-center gap-4 text-[11px] text-heritage-grey mt-0.5">
                          <span className="capitalize">{formatDate(doc?.uploadDate || '')}</span>
                          <span className="capitalize">{doc?.uploadedBy || ''}</span>

                        </div>}
                      </div>
                    </div>
                    <div className="flex items-center gap-2 flex-shrink-0">
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => handleDownload(doc)}
                        className="h-8 w-8 p-0 border-[#E2E5EA] text-text-grey hover:bg-white"
                        title="Download"
                      >
                        <Download className="h-4 w-4" />
                      </Button>
                      {canDelete && onDelete && (
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={() => onDelete(doc)}
                          className="h-8 w-8 p-0 text-hero-red hover:text-hero-red hover:bg-[rgba(235,28,55,0.08)]"
                          title="Delete"
                        >
                          <Trash2 className="h-4 w-4" />
                        </Button>
                      )}
                    </div>
                  </div>
                }
                </React.Fragment>
              ))}
            </div>
          )}
        </div>

      </DialogContent>
    </Dialog>
  );
}; 